import axios from 'axios';

export async function getGroupsDetails(groups) {
  return (await axios.get(`/groups-details?groups=${groups.join(',')}`)).data
}

export const getGroupsConfigurations = async (filters) => {
  const res = (await axios.get('/groups-configurations', { params: { ...filters } })).data
  return res;
}

export const checkGroupsConfigurationsForUpdates = async (groupsConfigurationsLastUpdate) => {
  const res = (await axios.get('/groups-configurations-last-update', { params: { groupsConfigurationsLastUpdate } })).data
  return res;
}
